<template>
  <vue-google-autocomplete
      :id="`autocomplete_${this._uid}`"
      :country="['au']"
      :placeholder="placeholder ? placeholder : 'Search for a location'"
      @placechanged="result => $emit('placechanged', result)"
      :fields="fields"
  >
  </vue-google-autocomplete>
</template>

<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {
  props: {
    placeholder: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
        fields: ['address_components', 'adr_address', 'alt_id', 'formatted_address', 'geometry', 'icon', 'name', 'business_status', 'photo', 'place_id', 'scope', 'type', 'url', 'utc_offset_minutes', 'vicinity']
    }
  },
  components: {
    VueGoogleAutocomplete
  }
}
</script>
